import { UserRoleDto } from '@/api/generated';
import Loader from '@/components/Loader.tsx';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { LocalStorageKey } from '@/utils/localStorage/localStorage.util.ts';
import { useAuthenticationDataContext } from '@/utils/providers/authetnitactionDataContext/useAuthenticationDataContext.tsx';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { QueryParams } from '@/utils/QueryParam.enum.ts';
import WelcomeAgainPage from '@/views/welcome/pages/WelcomeAgain.page.tsx';
import React, { useEffect } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';

import WelcomePage from './pages/Welcome.page';

const WelcomeView: React.FC = () => {
  const { isInitialized, user } = useUserContext();
  const { authenticationData } = useAuthenticationDataContext();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const sourceApp = searchParams.get(QueryParams.SOURCE_APP);
    if (sourceApp) {
      localStorage.setItem(LocalStorageKey.SOURCE_APP, sourceApp);
      searchParams.delete(QueryParams.SOURCE_APP);
      setSearchParams(searchParams);
    }
  }, []);

  const handleContinue = () => {
    navigate(RoutesEnum.QUIZ);
  };

  if (!isInitialized) {
    return <Loader className="min-h-dvh" />;
  }

  if (user?.role === UserRoleDto.Admin) {
    return <Navigate replace to={RoutesEnum.ADMIN} />;
  }

  if (!authenticationData?.authenticated) {
    return <WelcomePage />;
  }

  return <WelcomeAgainPage onClick={handleContinue} />;
};

export default WelcomeView;
